<div class="disable-confirm-container">
  <p class="disable-confirm-title alt-inter-bold alt-size-20">{{"FACILITATOR.tranfer-facilitator" | translate }} </p>
  <p class="disable-confirm-text-one alt-size-14 alt-inter-semibold ">{{"FACILITATOR.confirm-transfer-text" | translate
    | slice:0:33 }} "{{data.facilitatorName}}" {{"FACILITATOR.confirm-transfer-text" | translate | slice:33}}
    "{{data.organizationName}}" </p>
  <small class="disable-confirm-text-two alt-size-14 alt-inter-regular">{{"FACILITATOR.confirm-transfer-adverticing" |
    translate}}</small>


  <div class="btn-proceed alt-flex-end">
    <button class="btn-cancel alt-color-bran1 pointer alt-size-14  alt-inter-medium" type="button"
      [mat-dialog-close]="false">{{"USERS.go-back" |
      translate | uppercase }}</button>
    <button class="btn-agree alt-color-bran1 pointer alt-size-14  alt-inter-medium " type="button"
      [mat-dialog-close]="true">{{"FACILITATOR.accept-transfer"
      | translate | uppercase
      }}</button>
  </div>
</div>
